import { useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import api from "../../../../utils/api";
import { useMemo } from "react";
import { Chart } from "@highcharts/react";
import useOnScreen from "../../../../hooks/useOnScreen";
import moment from "moment";
import Loading from "../Loading";

const AdPlanServingHoursMenu = ({ adId, categoryId, marketPlace, organizationType, adPlanData }) => {
  const { t } = useTranslation(["advertising"]);
  const date = new Date();
  const start = new Date(date.setDate(date.getDate() - 1)).toISOString().slice(0, 10);
  let end = new Date(date.setDate(date.getDate() - 31)).toISOString().slice(0, 10);

  if (moment(end).isBefore(moment(adPlanData?.created_datetime))) {
    end = moment(adPlanData?.created_datetime).format("YYYY-MM-DD");
  }

  const innerCellRef = useRef(null);

  const isVisible = useOnScreen(innerCellRef);

  const { data, isLoading } = useQuery({
    queryKey: ["servingHours", adId, categoryId, marketPlace, organizationType],

    queryFn: async () => {
      const res = await api.get(`/api/serving_hours/${adId}/?start=${start}&end=${end}`);
      return res.data;
    },
  });

  const options = useMemo(() => {
    const items = [];
    if (data) {
      data.forEach((row) => {
        items.push([new Date(row.date).getTime(), row.serving_hours]);
      });
    }

    const orderedServingHoursData = items.sort((a, b) => {
      return a[0] - b[0];
    });

    const series = {
      name: t(($) => $.advertising["Day"]),
      color: "#a78dc2",
      data: orderedServingHoursData,
    };

    return {
      chart: {
        type: "column",
        style: {
          "font-family": "Poppins",
          "font-weight": 700,
          "font-size": "15px",
        },
      },
      title: {
        text: t(($) => $.advertising["Hours Served"]),
      },
      yAxis: {
        max: 24,
        endOnTick: 24,
        startOnTick: false,
        tickInterval: 4,
        title: {
          text: t(($) => $.advertising["Hour"]),
        },
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
          day: "%b %e",
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [series],
    };

    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isVisible, t]);

  return (
    <div ref={innerCellRef}>
      {isLoading && <Loading height={300} fullPage={false} />}
      {data && options && <Chart options={options} />}
    </div>
  );
};

export default AdPlanServingHoursMenu;
